import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, User, Eye, EyeOff, Loader2, ShieldCheck } from "lucide-react";
import { BrandLogo } from "@/components/Header";

export default function AdminLogin() {
  const { login, user, authReady } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (authReady && user) navigate("/admin"); }, [authReady, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success(`Welcome, ${data.name}`);
      navigate("/admin");
    } catch (err) { toast.error(apiError(err, "Invalid credentials")); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#FFFFFF] relative overflow-hidden px-4">
      <div className="absolute inset-0 grain opacity-40" />
      <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-teal-600/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full bg-amber-500/10 blur-3xl" />
      <form onSubmit={submit} className="relative oj-card p-8 w-full max-w-md" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-6">
          <BrandLogo className="h-11" />
          <div><div className="font-extrabold text-white text-lg">Admin CMS</div><div className="text-[10px] tracking-widest text-amber-600 uppercase">Identity Verification Gateway</div></div>
        </div>
        <h1 className="text-xl font-bold text-white mb-1">Super Admin Authentication</h1>
        <p className="text-sm text-slate-600 mb-6">Restricted access. All sign-ins are audited.</p>
        <div className="space-y-4">
          <div className="relative"><User className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-teal-500" /><input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@oojjascorporate.com" className="oj-input pl-11" data-testid="admin-email" /></div>
          <div className="relative">
            <KeyRound className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-teal-500" />
            <input required type={show ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="oj-input pl-11 pr-11" data-testid="admin-password" />
            <button type="button" onClick={() => setShow(!show)} className="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-500 hover:text-teal-600">{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
          </div>
          <button disabled={loading} className="oj-btn-gold w-full" data-testid="admin-login-submit">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />} Authenticate
          </button>
        </div>
        <p className="text-xs text-slate-500 text-center mt-5 font-mono">admin@oojjascorporate.com / Oojjas@2026</p>
      </form>
    </div>
  );
}
